import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LogAcaoCliente } from 'src/app/shared/models/log-acao-cliente-enum';

const assets = {
  cb: {
    creditCard: 'assets/images/icons/ic-cb-credit-card.svg',
    installmentIcon: 'assets/images/icons/ic-cb-parcelamento.svg'
  },
  pf: {
    creditCard: 'assets/images/icons/ic-pf-credit-card.svg',
    installmentIcon: 'assets/images/icons/ic-pf-parcelamento.svg'
  }
}

@Component({
  selector: 'app-step-cliente-sem-carne',
  templateUrl: './step-cliente-sem-carne.component.html',
  styleUrls: ['./step-cliente-sem-carne.component.scss']
})
export class StepClienteSemCarneComponent implements OnInit {
  isCasasBahia = location.href.indexOf('casasbahia') > 0 || location.href.indexOf('-cb') > 0;
  senha = '';
  LogAcaoCliente = LogAcaoCliente;
  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 1024px)');

  @Output()
  voltar: EventEmitter<null> = new EventEmitter();

  @Output()
  logAcaoCliente: EventEmitter<LogAcaoCliente> = new EventEmitter();

  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit(): void {
  }

  get brandName() {
    return this.isCasasBahia ? 'com as Casas Bahia' : 'com o Pontofrio';
  }

  get brandNameBtn() {
    return this.isCasasBahia ? 'Casas Bahia' : 'Pontofrio';
  }

  irParaLogin() {
    this.router.navigate(['/']);
  }

  enviarLogAcaoCliente(acaoCliente: LogAcaoCliente) {
    this.logAcaoCliente.emit(acaoCliente);
  }

  get assets() {
    if (this.isCasasBahia) {
      return assets.cb;
    }

    return assets.pf;
  }

}
